<template>
  <div class="row">
    <div class="col-md-6">
        <div class="dash-inner-box scholar-form mb-20">
        <form class="" id="scholarshipForm">
          <div class="dashboard-heading">
            <h1>{{eScholarship ? 'Update' : 'Add'}} New Scholarship</h1>
          </div>
          <div class="row p10-20">
            <div class="col-md-12">
              <input type="text" id="scholarTitle" placeholder="Scholarship Title" class="formTextFields saveField"
                     @blur="$parent.validateFiled($event)" data-type="isRequired" name="title"
                     v-bind:value="`${eScholarship ? eScholarship.title : ''}`"/>
              <p class="errorMsg"></p>
            </div>
            <div class="col-md-12">
              <input type="text" id="scholarAmt" placeholder="Scholarship Amount" @blur="$parent.validateFiled($event)"
                     data-type="number" data-id="reqAlso" name="amount" class="formTextFields saveField"
                     v-bind:value="`${eScholarship ? eScholarship.amount : ''}`" />
              <p class="errorMsg"></p>
            </div>
            <div class="col-md-12">
              <textarea id="scholarDetails" placeholder="Scholarship Details"
                  @blur="$parent.validateFiled($event)" data-type="isRequired" name="detail"
                  v-bind:value="`${eScholarship ? eScholarship.detail : ''}`"
                  class="formTextFields saveField"></textarea>
              <p class="errorMsg"></p>
            </div>
            <div class="col-md-12">
              <input type="text" id="scholarLink" placeholder="Scholarship Apply Link" class="formTextFields saveField"
                     @blur="$parent.validateFiled($event)" data-type="isRequired" name="apply_link"
                     v-bind:value="`${eScholarship ? eScholarship.apply_link : ''}`" />
              <p class="errorMsg"></p>
            </div>
            <div class="col-md-12 text-center">
              <button type="button" class="cpe-button" v-if="$parent.notchLoading === 'scholarshipForm'">
                <i class="fas fa-circle-notch fa-spin fa-fw"></i>
              </button>
              <button type="button" class="cpe-button" v-else-if="eScholarship"
                v-bind:data-id="eScholarship.college_scholarship_enc_id" @click="updateScholarShip()">
                  Update
              </button>
              <button type="button" class="cpe-button" v-else @click="saveScholarShip()">Add</button>
              <button type="button" class="cpe-button cp_cancelBtn" data-type="button" v-show="eScholarship" data-id="scholarship"
                      @click="$parent.cancelUpdate()" >Cancel
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="col-md-6">
      <div class="dash-inner-box">
        <div class="dashboard-heading">
          <h1>Existing Scholarships</h1>
        </div>
        <div class="accordion md-accordion p10-20" id="accordionEx1" role="tablist"
           aria-multiselectable="true">
        <!-- Accordion card -->
        <div class="card" v-for="s in $parent.scholarships">
          <!-- Card header -->
          <div class="card-header" role="tab" v-bind:id="`sa${s.college_scholarship_enc_id}`">
            <a class="collapsed" data-toggle="collapse" data-parent="#accordionEx1"
               v-bind:href="`#${s.college_scholarship_enc_id}`" aria-expanded="false"
               v-bind:aria-controls="s.college_scholarship_enc_id">
              <h5 class="mb-0 mt-0">
                {{ s.title }} <i class="fas fa-angle-down rotate-icon"></i>
              </h5>
            </a>
          </div>
          <!-- Card body -->
          <div v-bind:id="s.college_scholarship_enc_id" class="collapse" role="tabpanel"
               v-bind:aria-labelledby="`sa${s.college_scholarship_enc_id}`"
               data-parent="#accordionEx1">
            <div class="card-body">
              <h3>{{ s.title }}</h3>
              <p>{{ s.amount }}</p>
              <p>{{ s.detail }}</p>
              <a v-bind:href="s.apply_link">Apply Now</a>
              <div class="actionBtns">
                <button class="removeSch editBtn" v-bind:data-id="s.college_scholarship_enc_id" @click="editScholarship()">
                  Edit
                </button>
                <button class="removeSch" v-bind:data-id="s.college_scholarship_enc_id" @click="removeScholarship()">
                  Remove
                </button>
              </div>
            </div>
          </div>

        </div>
        <!-- Accordion card -->
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {requestHeaders} from "../../_helpers/apiHelper";

export default {
  name: "Scholarship",

  data(){
    return{
      eScholarship: null,
    }
  },
  mounted() {
  },
  methods:{
    saveScholarShip() {
      let scholarForm = document.querySelector('#scholarshipForm');
      let data = this.$parent.createDataObject(scholarForm);
      let hasError = scholarForm.querySelector('.hasError');
      if (hasError) {
        return false;
      }
      let self = this;
      self.$parent.notchLoading = 'scholarshipForm';
      axios.post(`${this.$parent.url}api/v2/college-profile/save-scholarships`, data, {headers: requestHeaders()}).then(
          function (response) {
            if (response.status == 200) {
              self.$parent.emptyFormFields(scholarForm);
              self.$parent.getScholarships()
              self.$parent.notchLoading = null;
            } else {
              self.$parent.notchLoading = null;
              toastr.error('Some error occurred. Try again later', 'Oops!!');
            }
          }
      )
    },
    removeScholarship() {
      let scholarship_id = event.currentTarget.getAttribute('data-id');
      let data = {'scholarship_id': scholarship_id};
      let self = this;
      axios.post(`${this.$parent.url}api/v2/college-profile/remove-scholarships`, data, {headers:requestHeaders()}).then(
          function (response){
            if(response['data']['response']['status'] == 200){
              self.$parent.getScholarships();
            }else{

            }
          }
      )
    },
    editScholarship(){
      let t = this;
      let sch_id = event.currentTarget.getAttribute('data-id');
      let editSch = t.$parent.scholarships.filter(
          scholarshipItem => scholarshipItem.college_scholarship_enc_id == sch_id,
      )
      t.eScholarship = editSch[0];
    },
    updateScholarShip(){
      let sch_id = event.currentTarget.getAttribute('data-id');
      let scholarForm = document.querySelector('#scholarshipForm');
      let data = this.$parent.createDataObject(scholarForm);
      data.append('scholarship_id', sch_id);
      let hasError = scholarForm.querySelector('.hasError');
      if (hasError){
        return false;
      }
      let self = this;
      self.$parent.notchLoading = 'scholarshipForm';
      axios.post(`${this.$parent.url}api/v2/college-profile/update-scholarships`, data, {headers:requestHeaders()}).then(
          function (response){
            if(response['data']['response']['status'] == 200){
              self.$parent.getScholarships();
              self.eScholarship = '';
              self.$parent.notchLoading = null;
            }else{
              self.$parent.notchLoading = null;
            }
          }
      )
    },
  }
}
</script>

<style scoped>
.card{
  box-shadow: none;
  border: 1px solid #f7f7f9;
}
</style>